import { RouteRecordRaw } from 'vue-router';

const invoiceRoutes: Array<RouteRecordRaw> = [
  {
    path: 'invoice/incoming',
    component: () =>
      import('@/app/invoice/components/incoming/incoming-invoices-index.vue'),
    name: 'app.invoice.incoming',
  },
  {
    path: 'invoice/outgoing',
    component: () =>
      import('@/app/invoice/components/outgoing/outgoing-invoices-index.vue'),
    name: 'app.invoice.outgoing',
  },
  {
    path: 'invoice/cash',
    component: () =>
      import('@/app/invoice/components/cash/cash-invoices-index.vue'),
    name: 'app.invoice.cash',
  },
  {
    path: 'invoice/mixed-voucher',
    component: () =>
      import('@/app/invoice/components/mixed-voucher/mixed-voucher-index.vue'),
    name: 'app.invoice.mixed_voucher',
  },
];

export default invoiceRoutes;
